import React, { memo, useCallback, useContext, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { AppHeaderHeightContext } from '../../../../contexts';
import { push } from '../../../../redux/actions';
import Logo from '../Logo';
import HeaderInfo from '../HeaderInfo';
import styles from './header.module.scss';
import NewsRow from '../../../../screens/ManualTrade/components/NewsRow';
import { HOME } from '../../../../constants';
import InformationBar from '../InformationBar';
import { useInformationBar } from '../../../../hooks';

const Header = ({ withoutSideBar, withHeaderInfo, containerClass }) => {
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);
  const { setHeaderHeight } = useContext(AppHeaderHeightContext);
  const { content } = useInformationBar();

  const handleNavigateToHome = useCallback(() => {
    dispatch(push(`/${HOME}`));
  }, [dispatch]);

  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (wrapper == null) {
      return;
    }
    setHeaderHeight(wrapper.offsetHeight);
  }, [setHeaderHeight, content]);

  return (
    <div
      ref={wrapperRef}
      className={classNames(styles.wrapper, containerClass, { [styles.withoutSideBar]: withoutSideBar })}
    >
      <Logo onClick={handleNavigateToHome} />
      {withHeaderInfo ? (
        <HeaderInfo />
      ) : (
        <>
          <NewsRow withTradeSettings={false} isHeader />
          <InformationBar />
        </>
      )}
    </div>
  );
};
Header.propTypes = {
  withoutSideBar: PropTypes.bool,
  withHeaderInfo: PropTypes.bool,
  containerClass: PropTypes.string.isRequired,
};
Header.defaultProps = {
  withoutSideBar: false,
  withHeaderInfo: false,
};

export default memo(Header);
